import React from "react";
import 'react-multi-carousel/lib/styles.css';
import CardViewChart from './chart/card-view-chart';
import TopCardView from './chart/top-card-chart';
import LeadViewChart from './chart/lead-view-chart';
import { Link, useNavigate } from 'react-router-dom';
import { connect } from "react-redux";
import Carousel from "react-multi-carousel";
import defaultPhoto from "../../assets/images/card-profile.png"
import ShimmerImage from "../../modules/default/popup/shimmerImage/shimmerImage";

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1,
        slidesToSlide: 1
    }
};
const handleShareCard = async (e, shareLink) => {
    e.preventDefault();
    try {
        if (navigator.share) {
            // Mobile sharing
            await navigator.share({
                title: document.title,
                url: shareLink
            });
            console.log('Thanks for sharing!');
        } else {
            // Desktop sharing - copy to clipboard
            await navigator.clipboard.writeText(shareLink);
            // You might want to show a toast or alert here
            alert('Link copied to clipboard!');
        }
    } catch (error) {
        console.error('Error sharing:', error);
    }
};
class CardChartDtl extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: null,
            expandedItem: null,
            user: "",
            password: "",
            affiliate: true,
            keyword: "",
            error: {},
            page: 1,
        };
    }
    changeHandler = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        });
    };


    componentDidMount() {
    }


    render() {
        // this.props.bodyClassController(this.props.pageData);

        let { cardData } = this.props;
        let allCards, cardPagination, totalData;
        if (cardData && cardData.data) {
            allCards = cardData.data.length ? cardData.data : null;
            cardPagination = cardData.pagination
                ? cardData.pagination
                : null;
            totalData = cardPagination.data_total
        }

        return (

            <section className="card-body-area">
                <div className="card-container">
                    <div className="card-row">
                        {/* Card body left content */}
                        <div className="card-col-5">
                            <div className="card-content-left">
                                <div className="card-carousel">
                                    {allCards && allCards.length > 0 ? (
                                        <Carousel responsive={responsive} arrows={false} showDots={true}>
                                            {allCards
                                                ? allCards.map((item) => {
                                                    return (
                                                        <div className="single-card" key={item.ID}>
                                                            <div className="card-body">
                                                                <div className="card-profile-image">
                                                                    <ShimmerImage
                                                                        src={item.preview_photo ? item.preview_photo : `https://avatar.iran.liara.run/username?username=${item.card_name}&background=f1f7ff&color=4491F5`}
                                                                        alt={item.card_title}
                                                                        width={98}
                                                                    />
                                                                </div>
                                                                <div className="card-footer">
                                                                    <div className="user-info">
                                                                        <h3>{item.card_name}</h3>
                                                                        <span>{item.card_title}</span>
                                                                    </div>
                                                                    <div className="footer-upload">
                                                                        <Link to={`/card/settings/${item.ID}`}>
                                                                            <i className="ri-edit-box-line"></i>
                                                                        </Link>
                                                                        <Link onClick={(e) => {handleShareCard(e, item.shareLink)}}>
                                                                            <svg width="26" height="33" viewBox="0 0 26 33"
                                                                                fill="none"
                                                                                xmlns="http://www.w3.org/2000/svg">
                                                                                <path
                                                                                    d="M19 12H22C23.6569 12 25 13.3431 25 15V29C25 30.6569 23.6569 32 22 32H4C2.34315 32 1 30.6569 1 29V15C1 13.3431 2.34315 12 4 12H7"
                                                                                    stroke="white" strokeWidth="2" />
                                                                                <path
                                                                                    d="M14.0001 3.82843V20H12.0001V3.82843L6.63614 9.1924L5.22192 7.7782L13.0001 0L20.7783 7.7782L19.3641 9.1924L14.0001 3.82843Z"
                                                                                    fill="white" />
                                                                            </svg>
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                                <div className="card-vector">
                                                                    <svg
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M240.225 100C177 170 61.3907 153.667 0 155V298C0 309.046 8.95432 318 20 318H515C526.046 318 535 309.046 535 298V36.5V20C535 8.95431 526.065 0 515.019 0H368.344C350.828 0 302.333 31.2355 240.225 100Z"
                                                                            fill="#4491F5" />
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                                : ""}
                                        </Carousel>
                                    ) : (
                                        <p>No cards display.</p>
                                    )}
                                </div>
                                {/* Card view chart */}
                                <CardViewChart />
                            </div>
                        </div>
                        {/* Card body right content */}
                        <div className="card-col-7">
                            <div className="card-report-area">
                                {/* View all card */}
                                <div className="card-widget total-card text-white">
                                    <div className="card-count">
                                        <h5 className="widget-value">{totalData}</h5>
                                        <span className="widget-title">Total cards</span>
                                        <Link className="card-btn create-new-card" to="/card/new">Create New</Link>
                                    </div>
                                    <Link to="/card" className="view-all-card" href="#">View All <i
                                        className="ri-arrow-right-s-line"></i></Link>
                                    <i className="ri-id-card-line"></i>
                                </div>
                                {/* Total Connects */}
                                <div className="card-widget total-connects">
                                    <h5 className="widget-value">705</h5>
                                    <span className="widget-title">Connects</span>
                                    <i className="ri-group-fill"></i>
                                </div>
                                {/* Total view */}
                                <div className="card-widget total-view">
                                    <h5 className="widget-value">643</h5>
                                    <span className="widget-title">Total View</span>
                                    <i className="ri-eye-fill"></i>
                                </div>
                                {/* Total view 2 */}
                                <div className="card-widget total-viewed text-white">
                                    <h5 className="widget-value">643</h5>
                                    <span className="widget-title">Total View</span>
                                    <i className="ri-eye-fill"></i>
                                </div>
                                {/* Total Completed */}
                                <div className="card-widget total-completed">
                                    <h5 className="widget-value">86%</h5>
                                    <span className="widget-title">Completed</span>
                                    <i className="ri-checkbox-circle-line"></i>
                                </div>
                                {/* Total Leads */}
                                <div className="card-widget total-leads text-white">
                                    <h5 className="widget-value">860</h5>
                                    <span className="widget-title">Leads</span>
                                    <i className="ri-user-2-fill"></i>
                                </div>
                            </div>
                            <div className="card-chart-right">
                                {/* Top card view chart */}
                                <TopCardView />

                                {/* Lead card view chart */}
                                <LeadViewChart />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

}

const mapStateToProps = (state) => ({
    pageData: state.pageData,
    cardData: state.cardData,
});
const mapDispatchToProps = {

};


function CardChart(props) {
    let navigate = useNavigate();
    return <CardChartDtl {...props} navigate={navigate} />
}

export default connect(mapStateToProps, mapDispatchToProps)(CardChart);